import { formatCartMoney } from 'lib/paperworkCart';

// A price from the owner's saved prices. Until it arrives, or when none is saved, an invisible placeholder of the
// same size keeps the layout, so a built-in number is never shown (Ivan 2026-10-15).
export default function Price({ minor }) {
  if (Number.isSafeInteger(minor)) return formatCartMoney(minor);
  return <span style={{ visibility: 'hidden' }} aria-hidden="true">$0,000</span>;
}
